import React, { memo } from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'I stopped dreading weekends. The Legacy Map made me realize I was holding onto guilt, not memories. Finished the garage in three sessions.',
    name: 'Robert M.',
    age: '71',
    location: 'Portland OR',
    context: 'Moved after 34 years'
  }, {
    quote: 'My daughter and I were barely speaking over the house stuff. The Family Meeting script changed everything. We sorted the living room together without a single argument.',
    name: 'James T.',
    age: '68',
    location: 'Austin TX',
    context: 'Downsized with wife'
  }, {
    quote: 'I went from 6 months of stalling to finishing in 3 weekends. The Decision Rules sheet is taped to my wall. Best $6 I ever spent.',
    name: 'William K.',
    age: '73',
    location: 'Scottsdale AZ',
    context: 'Downsized from 4BR to 2BR'
  }];
  return <section className="py-20 px-6 bg-white border-y border-[#D4C5A9]/20" data-id="element-339">
      <div className="max-w-[720px] mx-auto" data-id="element-340">
        <div className="text-center mb-16 fade-in-up" data-id="element-341">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-[#2B4257] mb-4" data-id="element-342">
            Men Who Finished
          </h2>
          <p className="text-lg text-[#5A5A5A]" data-id="element-343">
            Real results from the Downsizing Without Regret system.
          </p>
        </div>

        <div className="space-y-8" data-id="element-344">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-[#FAFAF7] p-8 rounded-xl border border-[#D4C5A9]/30 shadow-sm fade-in-up delay-${(index + 1) * 100}`} data-id="element-345">
              <div className="flex mb-4" data-id="element-346">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-[#D4C5A9] fill-[#D4C5A9] mr-1" data-id="element-347" />)}
              </div>

              <div className="relative mb-6" data-id="element-348">
                <Quote className="absolute -top-2 -left-2 w-8 h-8 text-[#D4C5A9]/20 transform -scale-x-100" data-id="element-349" />
                <p className="text-lg md:text-xl text-[#2B4257] italic font-serif leading-relaxed relative z-10 pl-4" data-id="element-350">
                  "{testimonial.quote}"
                </p>
              </div>

              <div className="flex items-center border-t border-[#D4C5A9]/20 pt-4" data-id="element-351">
                <div data-id="element-352">
                  <p className="font-bold text-[#2B4257] text-base" data-id="element-353">
                    {testimonial.name}, {testimonial.age}
                  </p>
                  <p className="text-sm text-[#5A5A5A]" data-id="element-354">
                    {testimonial.location} •{' '}
                    <span className="text-[#6B9B8A] font-medium" data-id="element-355">
                      {testimonial.context}
                    </span>
                  </p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}